module.exports = __webpack_public_path__ + "static/media/prueba3.6579effd.png";